import { createApp } from 'vue';
import ToastPlugin from 'vue-toast-notification';
import { fetchAuthState } from '@/utils/AuthService';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/css/tailwind.css';
import '@/assets/css/quill.snow.css';

const app = createApp(App);
// eslint-disable-next-line @typescript-eslint/no-empty-function
store.dispatch('user/onAuthChange', () => { });

fetchAuthState()
  .then(() => {
    // console.log('Auth state is fetched');
    app.use(store).use(router).use(ToastPlugin).mount('#app');
  })
  .catch((err: any) => {
    console.error('Error is auth', err);
    app.use(store).use(router).use(ToastPlugin).mount('#app');
  });
